import { PropsWithChildren, ReactElement } from 'react'

import { noop } from 'lodash'
import { Link } from 'react-router-dom'

import {
    ProductCatalogTabId,
    RETAIL_PERFORMANCE_TAB,
} from 'const/productCatalog'
import { productDetailUrl } from 'routing/urls'
import { CountryCode } from 'types'

interface ProductCatalogLinkProps {
    asin: string
    countryCode: CountryCode
    showAmazonIcon?: boolean
    onProductClick?: () => void
    tabId?: ProductCatalogTabId
}

function ProductCatalogLink({
    asin,
    countryCode,
    children,
    tabId = RETAIL_PERFORMANCE_TAB,
    onProductClick = noop,
}: PropsWithChildren<ProductCatalogLinkProps>): ReactElement | null {
    const url = productDetailUrl(asin, countryCode, tabId)
    return asin ? (
        <Link to={url} onClick={onProductClick}>
            {children}
        </Link>
    ) : null
}

export default ProductCatalogLink
